/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { ListView } from "antd-mobile";
import "./index.css";
import CartFoodGroup from "../CartFoodGroup";

class CartListing extends Component {
  constructor(props) {
    super(props);
  }

  onEndReached = event => {
    const { onEndReached } = this.props;

    onEndReached && onEndReached();
  };

  onEditFood = foodId => {
    const { onEditItem } = this.props;

    onEditItem && onEditItem(foodId);
  };

  onDeleteFood = foodId => {
    const { onDeleteItem } = this.props;

    onDeleteItem && onDeleteItem(foodId);
  };

  onDeliveryPressed = (foodId, isDelivery) => {
    const { onDeliveryPressed } = this.props;

    onDeliveryPressed && onDeliveryPressed(foodId, isDelivery);
  };

  render() {
    const { items, renderHeader, renderFooter, currency } = this.props;
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2
    });

    return (
      <ListView
        className={"cart-listing"}
        ref={el => (this.lv = el)}
        dataSource={dataSource.cloneWithRows(items)}
        renderSeparator={() => <div style={{ marginTop: "8px" }} />}
        renderHeader={() => renderHeader && renderHeader()}
        renderFooter={() => renderFooter && renderFooter()}
        renderRow={data => {
          return (
            <CartFoodGroup
              groupItem={data}
              currency={currency}
              onEditItem={this.onEditFood}
              onDeleteItem={this.onDeleteFood}
              onDeliveryPressed={this.onDeliveryPressed}
            />
          );
        }}
        pageSize={10}
        scrollRenderAheadDistance={500}
        onEndReached={this.onEndReached}
        onEndReachedThreshold={800}
        style={{
          height: "100%",
          width: "100%"
        }}
      />
    );
  }
}

CartListing.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  onEndReached: PropTypes.func,
  onEditItem: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onDeliveryPressed: PropTypes.func.isRequired
};

CartListing.defaultProps = {
  items: [],
  currency: "RM"
};

export default CartListing;



// WEBPACK FOOTER //
// ./src/components/CartListing/index.js